import { defineMessages } from 'react-intl-next';

export default defineMessages({
	flagTitle: {
		id: 'navigation.error.flag.title.non-final',
		defaultMessage: 'We couldn’t fetch your items',
		description: 'Title when an unknown error occurs',
	},
	flagDescription: {
		id: 'navigation.error.flag.description.non-final',
		defaultMessage: 'Please try again later',
		description: 'Description when an unknown error occurs',
	},
});
